import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Form, Modal } from "antd";
import { useIntl } from "react-intl";
import FloatingFormActions from "../../../components/forms/FloatingFormActions";
import { useSelector, useDispatch } from "react-redux";
import { setChangedFormItems } from "../patientDetailsSlice";
import { getChangedItems } from "../../../components/util/helpers";
import Spacer from "../../../components/layouts/Spacer";
import { getFormChanges } from "../../../components/util/helpers";
import RestrictedContext from "../../../components/util/RestrictedContext";
import { usePermission } from "../../../hooks/accessControl";
import { useParams } from "react-router-dom";
import { ExclamationCircleOutlined } from "@ant-design/icons";
var flatten = require("flat");

const FormWrapper = (props) => {
  const {
    mode,
    onSubmit,
    onFinishFailed,
    onDecline,
    saveLoading,
    children,
    fromCrm,
  } = props;
  const [form] = Form.useForm();
  const [modal, contextHolder] = Modal.useModal();
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const changedItems = useSelector(
    (state) => state.patientDetails.changedItems.changed
  );

  const changedVal = useSelector(
    (state) => state.patientDetails.changedItems.values
  );
  const dispatch = useDispatch();
  const intl = useIntl();
  useEffect(() => {
    dispatch(setChangedFormItems({ changed: [], values: {} }));
    const flat = flatten(activePatient, {
      safe: true,
    });

    form.setFieldsValue({
      ...flat,
      geo: activePatient.geo,
      subproject_id: activePatient.subproject && activePatient.subproject.name,
      branch_extension_id:
        activePatient.branch_extension && activePatient.branch_extension.name,
    });
  }, [activePatient, form, mode]);

  const onValuesChange = (changedValues, allValues) => {
    if (changedValues["passing_date"]) {
      showPassingDateAlert();
    }
    if (changedValues["masav_charge.deactivated"]) {
      form.setFieldValue("masav_charge.deactivated_reason", null);
    }
    const arr = getChangedItems(
      changedValues,
      allValues,
      changedItems,
      activePatient
    );
    dispatch(setChangedFormItems({ changed: arr, values: allValues }));
  };

  const onFinish = (values) => {
    const formChanges = getFormChanges(values, changedItems);
    onSubmit(formChanges);
  };

  const showPassingDateAlert = () => {
    const title = intl.formatMessage({
      id: "app.patients.passingDateTitle",
    });
    const content = intl.formatMessage({
      id: "app.patients.passingDateContent",
    });
    modal.confirm({
      title: title,
      icon: <ExclamationCircleOutlined />,
      content: content,
      onOk() {
        return;
      },
      onCancel() {
        form.setFieldsValue({
          ...changedVal,
          passing_date: null,
        });
        const allValues = { ...changedVal, passing_date: null };
        const arr = getChangedItems(
          { passing_date: null },
          allValues,
          changedItems,
          activePatient
        );
        dispatch(setChangedFormItems({ changed: arr, values: allValues }));
      },
    });
  };

  let { branchId } = useParams();
  const source = fromCrm ? "crm_patients" : "patients";
  const hasPermission = usePermission(branchId, source, "editor");

  return (
    <div>
      {contextHolder}
      <RestrictedContext.Provider value={{ hasWritePermission: hasPermission }}>
        <Form
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
          onValuesChange={onValuesChange}
        >
          {children}
          <Spacer vertical={true} extra={true} />
          <FloatingFormActions
            resource={"patients"}
            action={"editor"}
            onCancel={onDecline}
            mode={mode}
            formName={activePatient.first_name}
            onDecline={onDecline}
            hideDelete={true}
            hideDecline={true}
            saveLoading={saveLoading}
            saveText={intl.formatMessage({
              id: "app.actions.saveChanges",
            })}
            show={changedItems.length > 0}
          />
        </Form>
      </RestrictedContext.Provider>
    </div>
  );
};

FormWrapper.propTypes = {
  mode: PropTypes.string,
  onSubmit: PropTypes.func,
  onFinishFailed: PropTypes.func,
  onDecline: PropTypes.func,
  addImage: PropTypes.func,
  saveLoading: PropTypes.bool,
};

export default FormWrapper;
